export enum CompanyStatus {
  CUSTOMER = 'Customer',
  LEAD = 'Lead',
  CHURNED = 'Churned',
  BLOCKED = 'Blocked',
  FUTURE = 'Future',
}

export class Platform {
  id: number | null;
  name: string | null;
  description: string | null;
  domain: string | null;
}

export class KpiItem {
  name: string | null;
  value: number | null;
  percent: number | null;
  status: string | null;

  constructor() {
    this.name = null;
    this.value = null;
    this.percent = null;
    this.status = null;
  }
}
export class Kpi {
  mention: KpiItem | null;
  impressions: KpiItem | null;
  reach: KpiItem | null;
  engagement: KpiItem | null;
  impact: KpiItem | null;
  post: KpiItem | null;
  engagementRate: KpiItem | null;
  isAverage: boolean;
  channelId?: number;
  platformName?: string;
  constructor() {
    this.mention = new KpiItem();
    this.engagement = new KpiItem();
    this.impact = new KpiItem();
    this.impressions = new KpiItem();
    this.reach = new KpiItem();
    this.post = new KpiItem();
    this.engagementRate = new KpiItem();
    this.isAverage = false;
  }
}


export class IframePostDataModel {
  url: string;
  relative_path: string;
  influencer_id: number;
}

export class IframeDataModel {
  page: string;
  details: IframePostDataModel;
}

export class Advertiser {
  id: number;
  name: string;
  status: CompanyStatus;
  isTrialed?: boolean;
  inactive: boolean;
  startDate: Date;
}
export class Channel {
  id: number;
  handle: string;
  type: number;
  blogId: number;
  relativePath: string;
  platform: Platform;
  youtubeType: string;
  index?: number;
  constructor(id: number, handle: string, type: number, blogId: number, platform: Platform) {
    this.id = id;
    this.handle = handle;
    this.type = type;
    this.blogId = blogId;
    this.platform = platform;
  }
}



// WEBPACK FOOTER //
// ./src/models/common.ts